import { ExerciseType } from '../programItems';
import { PRESELECT_EXERCISE, REQUEST_EXERCISES, REQUEST_EXERCISES_SUCCESS } from './exercises.actionTypes';

export const actionCreators = {
	doRequestExercises: () => ({
		type: REQUEST_EXERCISES,
	}),
	doRequestExercisesSuccess: (exercises: ExerciseType[]) => ({
		type: REQUEST_EXERCISES_SUCCESS,
		exercises,
	}),
	doPreselectExercise: (exerciseId: string, workoutId: string) => ({
		type: PRESELECT_EXERCISE,
		exerciseId,
		workoutId,
	}),
};

export type ExerciseActionType =
	| ReturnType<typeof actionCreators.doRequestExercises>
	| ReturnType<typeof actionCreators.doRequestExercisesSuccess>
	| ReturnType<typeof actionCreators.doPreselectExercise>;
